export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_2.f3750dae.png";